import { atom } from "recoil";

export const isAddDebitAdjusment = atom({
  key: "isAddDebitAdjusment",
  default: false,
});

export const isAttachDebitAdjusment = atom({
  key: "isAttachDebitAdjusment",
  default: false,
});

export const cFields = atom({
  key: "cFields",
  default: [],
});

export const descriptions = atom({
  key: "descriptions",
  default: "",
});

export const completedData = atom({
  key: "completedData",
  default: undefined,
});
